import { createSlice } from '@reduxjs/toolkit';
import { clearReducers } from 'redux/logout';

export const initialState = {
  items: {},
  search: '',
  pageable: {
    pageNumber: 0,
    pageSize: 10,
  },
  loaded: false,
};

const zoneSlice = createSlice({
  name: 'zones',
  initialState,
  reducers: {
    initial: () => {},
    fetch: (state) => {
      state.loaded = false;
    },
    success: (state, action) => {
      state.loaded = true;
      action.payload.forEach((zone) => {
        state.items[zone.id] = zone;
      });
    },
    failure: (state) => {
      state.loaded = true;
    },
    updatePageable: (state, action) => {
      state.pageable.pageNumber =
        action.payload.pageSize !== state.pageable.pageSize
          ? 0
          : action.payload.pageNumber;
      state.pageable.pageSize = action.payload.pageSize;
    },
    updateSearch: (state, action) => {
      state.pageable.pageNumber = 0;
      state.search = action.payload;
    },
    resetFilters: (state) => {
      state.search = initialState.search;
      state.pageable = initialState.pageable;
    },
    updateZone: (state, action) => {
      state.items[action.payload.id] = action.payload;
    },
    removeZone: (state, action) => {
      delete state.items[action.payload];
    },
    refreshPage: () => {},
  },
  extraReducers: {
    [clearReducers]: () => initialState,
  },
});

export const { name, reducer, actions } = zoneSlice;
